import axios from "axios";

const BASE_API = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

const getAuthHeaders = () => {
  const token = localStorage.getItem("tali_client_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getEventsByRestaurant = async (restaurantId) => {
  try {
    const response = await axios.get(`${BASE_API}/events/restaurant/${restaurantId}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching events:", error);
    return { events: [], restaurantId, restaurantName: "" };
  }
};

/**
 * Fetch a single event by ID. Returns:
 *  - { event } when accessible
 *  - { event: null } when missing
 *  - { event: null, accessDenied: true, message } when private and the user is not invited
 */
export const getEventById = async (eventId) => {
  try {
    const response = await axios.get(`${BASE_API}/events/${eventId}/details`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 403) {
      return {
        event: null,
        accessDenied: true,
        message: error.response?.data?.message || "This is a private event. You don't have access.",
      };
    }
    console.error("Error fetching event:", error);
    return { event: null };
  }
};

export const getAllEvents = async () => {
  try {
    const response = await axios.get(`${BASE_API}/events`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching all events:", error);
    return { events: [] };
  }
};

/**
 * Check whether the current user has access to a (potentially private) event.
 * Returns { exists, isInvitationOnly, hasAccess }.
 */
export const checkEventAccess = async (eventId) => {
  try {
    const response = await axios.get(`${BASE_API}/events/${eventId}/access`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error checking event access:", error);
    return { exists: false, isInvitationOnly: false, hasAccess: false };
  }
};
